import "./TopBar.css";

import Filters from "../Filters/Filter/Filter";
import PublicHeader from "../PublicHeader/PublicHeader";

const TopBar = ({
  profileUser,
  handleShare,

  filter,
  selectedScrip,
  selectedPartner,

  uniqueScrips,
  uniquePartners,

  setFilter,
  setSelectedScrip,
  setSelectedPartner,
  userId,
privacy,
setPrivacy,
}) => {

  return (
    <div className="top-bar">

      <PublicHeader
  profileUser={profileUser}
  handleShare={handleShare}

  userId={userId}
  privacy={privacy}
  setPrivacy={setPrivacy}
/>

      <div className="filters-wrapper">

        <Filters
          filter={filter}
          selectedScrip={selectedScrip}
          selectedPartner={selectedPartner}
          uniqueScrips={uniqueScrips}
          uniquePartners={uniquePartners}
          onFilterChange={(e) => setFilter(e.target.value)}
          onScripChange={(e) => setSelectedScrip(e.target.value)}
          onPartnerChange={(e) => {
            const selected = uniquePartners.find(
              p => p.id === e.target.value
            );

            setSelectedPartner(
              selected || {
                id: "all",
                name: "all"
              }
            );
          }}
        />

      </div>

    </div>
  );
};

export default TopBar;